import React from 'react'

import './HomeSection2.css'
import homeImg3 from "../../../../assets/imgs/homeImg3.png"
import cdImg from "../../../../assets/imgs/cdImg.png"
import ssimg from "../../../../assets/imgs/ssimg.png"

function HomeSection2() {
  return (
    <div className='hs1'>
         <span className='hs1-head'>WHY CHOOSE US</span>
        <span className='hs1-title'>WHY Sync Verse</span>
        <div className='hs2-inner'>
            <div className="hs2-left">
                <img src={homeImg3} alt="" />
            </div>
            <div className="hs2-right">
                <div className='hs2-upper'>
                    <div className='hs2-upper-left'>
                        <img src={cdImg} alt="" />
                        <span>Creative Design</span>
                        <p>Lorem ipsum dolor sit amet consectetur. sed duis eros pulvinar elementum.</p>
                    </div>
                    <div className='hs2-upper-left'>
                        <img src={ssimg} alt="" />
                        <span>Smart Solution</span>
                        <p>Lorem ipsum dolor sit amet consectetur. sed duis eros pulvinar elementum.</p>
                    </div>
                </div>
                <p className=''>Lorem ipsum dolor sit amet consectetur. Bibendum eu purus duis integer feugiat tempus. Ante varius condimentum nibh sollicitudin vivamus lacus. Volutpat at fames faucibus bibendum. Lorem ipsum dolor sit amet consectetur. Bibendum eu purus duis integer feugiat tempus. Ante varius condimentum nibh sollicitudin vivamus lacus.</p>
                <div className='hs2-btns'>
                    <span className='hs2-btn1'>Read More</span>
                    <span className='hs2-btn2'>See Products</span>

                </div>
            </div>

        </div>
    </div>
  )
}

export default HomeSection2
